import {
  ColorSwatch as MantineColorSwatch,
  ColorSwatchProps,
} from '@mantine/core';

export type IColorSwatchProps = ColorSwatchProps;

/** @registry Design-layer pass-through over Mantine ColorSwatch; import this instead of @mantine/core ColorSwatch outside src/design. */
export const ColorSwatch = MantineColorSwatch;
